// =====================================
//
//   Other Controller
//   Author: Wayne
//   createtime: 2016 / 08 / 29
//
// =====================================

window.InifECMobileApp.controller("OtherController", ['$scope', '$state', '$timeout', '$rootScope', 
    'UserService', 'MessageService', '$localStorage', 'OrderService', '$stateParams', '$InifECGA',
	function($scope, $state, $timeout, $rootScope, 
        UserService, MessageService, $localStorage, OrderService, $stateParams, $InifECGA) {

        // --------------------------------
        // 更新通知訊息最後讀取時間
        // --------------------------------
        var updateLastopentime = function() {

            MessageService.updateLastopentime($scope.lastopentime);
        }

        // --------------------------------
        // [private] 取得使用者資訊
        // --------------------------------
        var getUserInfo = function(skipCache) {

            UserService.getUserInfo(skipCache).then(function(result) {
                $scope.isLogin = true;
                getAllMsgs();

            }, function(error) {
                $scope.isLogin = false;
            });
        }


        // -------------------------------
        // 登入
        // -------------------------------
        var login = function() {
            
            $rootScope.$broadcast('OPEN_LOGIN_MODAL');
        }

        // -------------------------------
        // 登出
        // -------------------------------
        var logout = function() {

            $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                title: '確定登出inif印衣服？',
                description: '',
                callback: function(result) {
                    if(result) {

                        const mrscid = UserService.user.id;

                        $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                            title: '正在登出',
                        });

                        UserService.logout().then(function(result) {
                            $scope.isLogin = false;
                            $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                                title: '登出成功',
                            });
                            $rootScope.$broadcast('LOGOUT_SUCCESS');

                            $InifECGA.setMrscid("");
                            $InifECGA.eventTrack('member', 'logout', mrscid);
                        }, function(error) {
                            $scope.isLogin = false;
                            $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                                title: '系統發生錯誤',
                            });
                        });
                    }
                }
            });
        }

        var getOrderPayBadget = function() {

            OrderService.getOrderPayBadget().then(function(result){
                if(!window.isNaN(result)) {
                    $scope.orderPayBadget = result;
                }
            });
        };

        // --------------------------------
        // [private] 取得所有系統通知訊息以及最後讀取時間
        // --------------------------------
        var getAllMsgs = function() {

            var msgBadget = 0;
            
            MessageService.getAllMsgs().then(function(result) {

                if(result && Array.isArray(result.msgs) && result.msgs.length > 0) {
                    $scope.messageList = result.msgs;

                    if(!$localStorage.message.lastopentime) {
                        $localStorage.message.lastopentime = result.lastopentime;
                    }

                    $scope.lastopentime = result.lastopentime;

                    for(var i = 0; i < $scope.messageList.length; i++) {
                        
                        if($scope.messageList[i].createtime < $localStorage.message.lastopentime) {
                            break;
                        }

                        $scope.messageList[i].isNew = true;
                        msgBadget++;
                    }

                    MessageService.setMsgBadget(msgBadget);

                } else if($scope.messageList.length == 0) {
                    $scope.isMessageEmpty = true;
                }

            }, function(error) {

                $scope.isMessageError = true;
            });
        };

        // -------------------------------
        // 註冊
        // -------------------------------
        var register = function() {
            
            $rootScope.$broadcast('OPEN_REGISTER_MODAL');
        }

        var init = function() {
            if(!$rootScope.useNativeLoginModal){
                $rootScope.useNativeLoginModal = $stateParams.useNativeLoginModal;    
            }            
            getUserInfo(false);
            getOrderPayBadget();
        };


	    //==========================
        //  Events
        //==========================
        $scope.$on('LOGIN_SUCCESS', function(event, data){
            $scope.isLogin = true;
        });

        $scope.$on('LOGOUT_SUCCESS', function(event, data){
            $scope.isLogin = false;
        });

        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            $scope.state = $state.current.name;

            if($scope.state == window.STATES.OTHER && $scope.isLogin) {
                getAllMsgs();    
            }
        });     

        //==========================
        //  Members
        //==========================
        $scope.isLogin = false;
        $scope.messageinfo = MessageService.message;
        $scope.lastopentime;
        $scope.messageList = [];
        $scope.isLoadingMsg = false;

        $localStorage.$default({
            message: {},
        });

        $scope.cms_blog_url = CMS_URL + '/blog';
        $scope.cms_project_url = CMS_URL + '/project';
        $scope.cms_resource_url = CMS_URL + '/resource';

        //==========================
        //  Methods
        //==========================
        $scope.updateLastopentime = updateLastopentime;
        $scope.login = login; // 登入
        $scope.logout = logout; // 登出
        $scope.register = register; // 註冊
        $scope.orderPayBadget = 0;


        //==========================
        //  Init
        //==========================
        init();
	}
]);